"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var AppPaySystemWalletEditor = /** @class */ (function (_super) {
    __extends(AppPaySystemWalletEditor, _super);
    function AppPaySystemWalletEditor(props) {
        return _super.call(this, props) || this;
    }
    AppPaySystemWalletEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    wallet: _item.wallet,
                    pool_tag: _item.pool_tag,
                    description: _item.description,
                    is_locked: _item.is_locked,
                    wallet_crypto_currency_code: _item.wallet_crypto_currency_code,
                    wallet_crypto_currency_title: _item.wallet_crypto_currency_title
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Изменить кошелек"]);
                });
            }
        }
        else {
            this.setState({
                wallet: "",
                pool_tag: "",
                description: "",
                is_locked: false,
                wallet_crypto_currency_code: 0,
                wallet_crypto_currency_title: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создать кошелек"]);
            });
        }
        this.doReSetRules();
    };
    AppPaySystemWalletEditor.prototype.doReSetRules = function () {
        this.setState({
            wallet_rules: { isError: false },
            pool_tag_rules: { isError: false },
            wallet_crypto_currency_rules: { isError: false }
        });
    };
    AppPaySystemWalletEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                wallet: this.state.wallet,
                pool_tag: this.state.pool_tag,
                is_locked: this.state.is_locked,
                description: this.state.description,
                wallet_crypto_currency_code: this.state.wallet_crypto_currency_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Кошелек изменен!");
            });
        }
    };
    AppPaySystemWalletEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.wallet) || (this.state.wallet.length === 0)) {
            this.setState({
                wallet_rules: {
                    isError: true,
                    errorMessage: "Название кошелька не заполнено!"
                }
            });
            return false;
        }
        if ((!this.state.pool_tag) || (this.state.pool_tag.length === 0)) {
            this.setState({
                pool_tag_rules: {
                    isError: true,
                    errorMessage: "Название пула не заполнено!"
                }
            });
            return false;
        }
        if ((this.state.wallet_crypto_currency_code == 0) || (this.state.wallet_crypto_currency_title.length === 0)) {
            this.setState({
                pool_tag_rules: {
                    isError: true,
                    errorMessage: "Тип кошелька не выбран!"
                }
            });
            return false;
        }
        return true;
    };
    AppPaySystemWalletEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                wallet: this.state.wallet,
                pool_tag: this.state.pool_tag,
                is_locked: this.state.is_locked,
                description: this.state.description,
                wallet_crypto_currency_code: this.state.wallet_crypto_currency_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Кошелек добавлен");
            });
        }
    };
    AppPaySystemWalletEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AppPaySystemWalletEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить кошелек";
        }
        else {
            return "Изменить кошелек";
        }
    };
    AppPaySystemWalletEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 420 },
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Кошелек",
                    placeholder: "Введите кошелек"
                }, value: this.state.wallet, onValueChanged: function (newVal) {
                    _this.setState({
                        wallet: newVal,
                        wallet_rules: { isError: false }
                    });
                }, required: true, rules: this.state.wallet_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Пул кошельков",
                    placeholder: "Введите название пула кошельков"
                }, value: this.state.pool_tag, onValueChanged: function (newVal) {
                    _this.setState({
                        pool_tag: newVal,
                        pool_tag_rules: { isError: false }
                    });
                }, required: true, rules: this.state.pool_tag_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Описание",
                    placeholder: "Введите описание"
                }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: {
                    caption: "Тип кошелька",
                    placeholder: "Выберите тип кошелька"
                }, value: { key: this.state.wallet_crypto_currency_code, value: this.state.wallet_crypto_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        wallet_crypto_currency_code: newVal.key,
                        wallet_crypto_currency_title: newVal.value,
                        wallet_crypto_currency_rules: { isError: false }
                    });
                }, items: this.props.availWalletCurrencyTypes, disabled: this.props.record != null, required: true, rules: this.state.wallet_crypto_currency_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                    btnEdit: "Изменить",
                    btnNew: "Создать",
                    btnGoBack: "Назад"
                }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return AppPaySystemWalletEditor;
}(React.Component));
exports.default = AppPaySystemWalletEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_wallets/ui/component/AppPaySystemWalletEditor.tsx
// module id = 2563
// module chunks = 0